// routes/_app.membership.plans.tsx
import type { ClientLoaderFunctionArgs } from 'react-router'
import { MembershipPageTab } from '~/pages/Membership/constants'
import { createMembershipRouteHandle } from '~/pages/Membership/route-utils'
import { createRedirect } from '~/utils/router/route'
import type { Route } from './+types/_app.membership.plans'

const getClientModule = () => import('src/clientRoutes/_app.membership.plans')

export const handle = createMembershipRouteHandle({
  name: 'membership/plans',
  track: { scene: 'membership' },
  hideMembershipBanner: true,
  showCreditPill: true,
  pageTab: MembershipPageTab.plans,
})

export function loader({ request }: Route.LoaderArgs) {
  const url = new URL(request.url)
  if (url.searchParams.has('mode')) {
    return createRedirect(
      request,
      url.searchParams.get('mode') === 'packs' ? '../credit-packs' : '.',
      { mode: undefined },
    )
  }
  return null
}

export async function clientLoader(args: ClientLoaderFunctionArgs) {
  const { loader } = await getClientModule()
  return loader(args)
}
clientLoader.hydrate = true

export default function Page() {
  return null
}
